export default {
  app: {
    title: 'Overpass Planner',
    labs: 'LABS',
  },
  toolbar: {
    layers: 'Capas',
    filters: 'Filtros',
    monitoredAreas: 'Áreas monitoreadas',
    settings: 'Configuración',
  },
  layers: {
    baseMaps: 'Mapas base',
    cloudLayers: 'Capas de nubes',
    eumetsatTrueRgb: 'EUMETSAT True RGB',
    eumetsatIr: 'EUMETSAT IR 10.8',
    opacity: 'Opacidad',
    overlays: 'Superposiciones',
    satelliteOverpasses: 'Sobrevuelos de satélites',
    aoiCoverage: 'Cobertura ADI',
    hexGrid: 'Cuadrícula hexagonal (Próximo sobrevuelo)',
  },
  filters: {
    title: 'Filtros',
    savePreset: 'Guardar preajuste',
    deletePreset: 'Eliminar preajuste',
    info: 'Info',
    preset: 'Preajuste',
    cloudCoverForecast: 'Pronóstico de cobertura nubosa',
    cloudCoverDescription: 'Ocultar sobrevuelos con pronóstico de cobertura nubosa superior a este umbral.',
    satellites: 'Satélites',
    satellitesFilter: 'Filtrar por satélite',
    satellitesDescription: 'Satélites agrupados por tipo de sensor.',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    ororaTechSafire: 'OroraTech SAFIRE',
    showGrouped: 'Mostrar agrupado',
    showIndividual: 'Mostrar individuales',
    predicted: 'Trayectoria orbital',
    scheduled: 'Programado',
    scheduledOnlyNote: 'Las adquisiciones programadas son ventanas de tareas confirmadas, disponibles solo para las próximas 48 horas. La trayectoria orbital es predicha y cubre todo el rango.',
    retired: 'retirado',
    backup: 'respaldo',
    allSatellites: 'Todos los satélites',
    customPreset: 'Preajuste personalizado',
    manual: 'Manual',
    selectedOfTotal: '{selected} de {total} seleccionados',
  },
  monitor: {
    title: 'Monitor',
    addArea: 'Agregar área',
    dropzoneTitle: 'Arrastra y suelta archivos GeoJSON aquí',
    dropzoneSubtitle: 'o haz clic para buscar',
    dropzoneHint: '.geojson o .json — máx. 5 MB por archivo',
    dropFiles: 'Soltar para subir',
    noAreasYet: 'Sin áreas monitoreadas aún',
    noAreasDescription: 'Seleccione un ADI del menú desplegable y haga clic en {action} para calcular la cobertura.',
    compute: 'Calcular',
    name: 'Nombre',
    overpasses: 'Sobrevuelos',
    calculated: 'Calculado',
    computing: 'Calculando...',
    area: 'Área',
    export: 'Exportar',
    delete: 'Eliminar',
    clickToPan: 'Clic para centrar, doble clic para renombrar',
    selected: '{count} seleccionado(s)',
  },
  list: {
    title: 'Sobrevuelos',
    satellite: 'Satélite',
    direction: 'Dirección',
    start: 'Inicio',
    end: 'Fin',
    sensor: 'Sensor',
    resolution: 'Resolución',
    light: 'Luz',
    cloud: 'Nubes',
    latency: 'Latencia',
    delivery: 'Entrega',
    loading: 'Cargando datos de satélite...',
    zoomIn: 'Acerque para ver sobrevuelos individuales.',
    noOverpasses: 'No hay sobrevuelos visibles con los filtros actuales.',
    uploadAoiToView: 'Cargue un área de interés para ver los datos de sobrevuelo.',
    selectGridCell: 'Seleccione una celda de la cuadrícula para ver los datos de sobrevuelo.',
    day: 'día',
    night: 'noche',
    close: 'Cerrar',
    maxCloudCover: 'Cobertura nubosa máx: {value}%',
  },
  popup: {
    start: 'Inicio',
    end: 'Fin',
    direction: 'Dirección',
    ascending: 'Ascendente',
    descending: 'Descendente',
    sensor: 'Sensor',
    resolution: 'Resolución',
    constellation: 'Constelación',
    daylight: 'Luz diurna',
    day: 'Día',
    night: 'Noche',
    dayEmoji: '☀ Día',
    nightEmoji: '🌙 Noche',
    cloudCoverForecast: 'Pronóstico de cobertura nubosa',
    cloudCoverObserved: 'Nubosidad (observada)',
    notCalculated: 'No calculado',
    expectedLatency: 'Latencia esperada',
    expectedDelivery: 'Entrega esperada',
    from: 'Desde',
    to: 'Hasta',
    coverage: '{pct}% Cobertura',
    areaCovered: 'Área cubierta',
  },
  timeline: {
    title: 'Gráfico de línea de tiempo',
    coveragePct: 'Cobertura %',
    allSatellites: 'Todos los satélites',
    bySatellite: 'Por satélite',
    bySensor: 'Por sensor',
    restore: 'Restaurar',
    maximize: 'Maximizar',
    close: 'Cerrar',
    uploadAoiTimeline: 'Cargue un área de interés para ver la línea de tiempo.',
    selectGridTimeline: 'Seleccione una celda de la cuadrícula para ver la línea de tiempo.',
  },
  hexLegend: {
    title: 'Tiempo hasta el próximo sobrevuelo',
    expandLegend: 'Expandir leyenda',
    collapseLegend: 'Contraer leyenda',
    noOverpasses: 'Sin sobrevuelos en las próximas {hours} horas',
    notComputed: 'No calculado para este periodo',
    coveragePast: 'La cuadrícula se precalcula hacia adelante desde la última compilación: las pasadas anteriores no están disponibles aquí. Usa la vista de franjas o ADI para fechas pasadas.',
    coverageOtOnly: 'Después del {date} la cuadrícula solo cubre la constelación OroraTech.',
    coverageBeyondAll: 'La cuadrícula termina el {date}. No hay nada precalculado más allá.',
    cellsSelected: '{count} celda(s) seleccionada(s)',
    clear: 'Limpiar',
  },
  hexTooltip: {
    nextOverpass: 'Próximo sobrevuelo',
    satellite: 'Satélite',
    acquisition: 'Hora de adquisición',
    cloudForecast: 'Pronóstico nuboso',
    status: 'Estado',
    noOverpass: 'Sin sobrevuelo en la ventana seleccionada',
    timeIn: 'En',
    totalPasses: 'Total de pasadas',
  },
  settings: {
    language: 'Idioma',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    timezone: 'Zona horaria',
    local: 'Local',
    colorblindFriendly: 'Colores aptos para daltónicos',
  },
  timeControls: {
    start: 'Inicio',
    end: 'Fin',
    now: 'Ahora',
    showGraph: 'Mostrar gráfico',
    hideGraph: 'Ocultar gráfico',
    showPanel: 'Mostrar panel',
    hidePanel: 'Ocultar panel',
    setStartToNow: 'Establecer inicio a ahora',
    resetTimeRange: 'Restablecer rango de tiempo',
    gridCoverageHint: 'Precalculado: todos los satélites hasta {allSatellitesEnd}, solo OroraTech hasta {end}. Sin fechas pasadas.',
  },
  viewToggle: {
    aoi: 'ADI',
    grid: 'Cuadrícula',
    swaths: 'Franjas',
    aoiTitle: 'Vista ADI — Mostrar solo cobertura ADI',
    gridTitle: 'Vista cuadrícula — Tiempo hasta el próximo sobrevuelo',
    swathTitle: 'Vista de franjas',
  },
  geocoder: {
    searchPlaceholder: 'Buscar ubicación…',
    coordinates: 'Coordenadas',
    noResults: 'Sin resultados para',
    clearSearch: 'Borrar búsqueda',
    trackGeolocation: 'Seguir geolocalización',
    toggleGeolocation: 'Alternar geolocalización',
  },
  aoi: {
    selectOrUpload: 'Seleccionar o cargar ADI…',
    compute: 'Calcular',
    computing: 'Calculando…',
    uploadGeoJson: 'Cargar GeoJSON ADI',
    aoiLabel: 'ADI',
    clearAoi: 'Borrar ADI',
    uploadNew: 'Cargar nuevo GeoJSON…',
    computeCoverage: 'Calcular cobertura',
  },
  startup: {
    title: 'Comience con un área de interés',
    body: 'Cargue un ADI para ejecutar cálculos de cobertura, o continúe con una vista global.',
    dropzoneTitle: 'Arrastra y suelta archivos GeoJSON aquí',
    dropzoneSubtitle: 'o haz clic para buscar',
    dropzoneHint: '.geojson o .json — máx. 5 MB por archivo',
    or: 'o',
    uploadAoi: 'Cargar ADI',
    continueGlobal: 'Continuar a vista global',
  },
  common: {
    zoomInHint: 'Acerque para ver la información de sobrevuelo de satélites',
    openOverpassList: 'Abrir lista de sobrevuelos',
    cloudCoverForecast: 'Pronóstico de cobertura nubosa',
    groupedConstellation: 'Constelación agrupada',
    individualSatellites: 'Satélites individuales',
  },
};
